import { Component, OnInit, ViewChild } from '@angular/core';
import { InfoService } from '../_services/info.service';
import { UntypedFormGroup, UntypedFormControl, Validators, AbstractControl } from '@angular/forms';
import { GatesService } from '../_services/gates.service';
import { GlobalService } from 'src/app/_services/global.service';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { MultiSelect } from 'primeng/multiselect';
import { ErrorMsgService } from 'src/app/shared/error-msg/error-msg.service';

declare var $: any;

@Component({
  selector: 'app-add-gate',
  templateUrl: './add-gate.component.html',
  styleUrls: ['./add-gate.component.scss']
})
export class AddGateComponent implements OnInit {
  mapControls;
  securities = [];
  primeSelectSecurities = [];
  grades = [];
  primeSelectGrades = [];
  gate = { lat: 0, long: 0, area: 0 };
  addGateForm: UntypedFormGroup;
  mode = 'add';
  state;
  gateId;
  infoClass = false;
  schoolArea: number;
  currLang;
  modalClosed = false;
  @ViewChild('multiSelectGateGrades') multiSelectgrades: MultiSelect;
  @ViewChild('multiSelectGateGuards') multiSelectguards: MultiSelect;

  constructor(
    private infoService: InfoService,
    private globalService: GlobalService,
    private translate: TranslateService,
    private dataService: DataService,
    private gateService: GatesService,
    private errorMsgService: ErrorMsgService,
  ) {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
  }

  ngOnInit(): void {
    this.initMapControls();
    $(document).on('hidden.bs.modal', '#addGateModal', () => {
      this.closeModalHandler();
    })
    $(document).on('shown.bs.modal', '#addGateModal', () => {
      if(this.mode == 'add'){
        this.dataService.getAllGrades().subscribe((res:any)=>{ 
          this.grades = res;       
          // this.grades = res.filter(grades => grades.gates.length == 0);  
          this.mapPrimeSelectArrays(this.grades , 'grade');
        }) 
      }
    })
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.translate.get('init').subscribe(res => {
      this.state = this.translate.instant('gates.add-gate-modal.add')
    });
    this.translate.onLangChange.subscribe(res => {
      this.state = this.translate.instant('gates.add-gate-modal.add')
    });
    this.addGateForm = new UntypedFormGroup({
      name: new UntypedFormControl('', [Validators.required, Validators.maxLength(20), Validators.pattern('^[\a-zA-z0-9-_\u0621-\u064A\u0660-\u0669 ]+$')]),
      guards_ids: new UntypedFormControl(''),
      grade_ids: new UntypedFormControl(''),
      area: new UntypedFormControl('', [Validators.required, Validators.pattern('[0-9]*')]),
      lat: new UntypedFormControl('', [Validators.required]),
      long: new UntypedFormControl('', [Validators.required]),
    })

    this.gateService.getGateData().subscribe(res => {  
      if (res) {
        // the user is editing a gate
        this.grades = res['grades'];
        this.gateService.getSecurity().subscribe((res: any) => {
          this.securities = res;
          this.mapPrimeSelectArrays(this.securities , 'guard');
        })
        this.dataService.getAllGrades().subscribe((res:any)=>{
          this.grades = res;
          // this.grades = [... this.grades , ...res.filter(grades => grades.gates.length == 0)]; 
          // this.grades = [...new Map(this.grades.map(item => [item['name'], item])).values()]
        }) 
        this.mapPrimeSelectArrays(this.grades , 'grade');
        this.mode = 'edit';
        this.translate.get('init').subscribe(res => {
          this.state = this.translate.instant('gates.add-gate-modal.edit')
        });
        this.translate.onLangChange.subscribe(res => {
          this.state = this.translate.instant('gates.add-gate-modal.edit')
        });
        this.gateId = res['id'];
        let editKeys = ['name', 'users', 'lat', 'long', 'area','grades'];
        for (const key of editKeys) {
          if (key === 'users') {
            let guards_ids = [];
            res['users'].map(user => {
              guards_ids.push(user.id);
            })
            this.addGateForm.controls['guards_ids'].setValue(guards_ids);
          }
          else if (key === 'grades') {
            let grade_ids = [];
            res['grades'].map(grade => {
              grade_ids.push(grade.id);
            })
            this.addGateForm.controls['grade_ids'].setValue(grade_ids);
          }
          else {
            this.addGateForm.controls[key].setValue(res[key]);
          }
        }
        this.gate.lat = res['lat'];
        this.gate.long = res['long'];
        this.gate.area = res['area'];
        this.setMapData();
      }
    })

    this.gateService.getSecurity().subscribe((res: any) => {
      this.securities = res;
      this.mapPrimeSelectArrays(this.securities , 'guard');
    })

    // this.dataService.getAllGrades().subscribe((res:any)=>{
      
    //   this.grades = res.filter(grades => grades.gates.length == 0);
      
    // })

    this.dataService.getSchoolInfo().subscribe((res: any) => {
      let selectedSchool;
      selectedSchool = res.find(school=> school.selected == true);
      this.gate.lat = selectedSchool.lat;
      this.gate.long = selectedSchool.long;
      // this.gate.area = selectedSchool.zone;
      this.schoolArea = selectedSchool.zone;
      this.setMapData();
      this.addGateForm.controls.lat.setValue(this.gate.lat);
      this.addGateForm.controls.long.setValue(this.gate.long);
    })
  }

  getAddGateFormValidation(control: string) {
    let errorMsg;
    switch (control) {
      case 'name':
        if (this.addGateForm.controls[control].errors) {
          errorMsg = this.addGateForm.controls[control].errors.required ? this.translate.instant('gates.add-gate-modal.gate-required') :
            this.addGateForm.controls[control].errors.maxlength ? this.translate.instant('gates.add-gate-modal.gate-length') :
              this.translate.instant('gates.add-gate-modal.gate-valid');
        }

        break;
      case 'area':
        if (this.addGateForm.controls[control].errors) {
          errorMsg = this.addGateForm.controls[control].errors.required ? this.translate.instant('gates.add-gate-modal.zone-required') :
            this.addGateForm.controls[control].errors.incorrect ? this.translate.instant('gates.add-gate-modal.zone-area') :
              this.translate.instant('gates.add-gate-modal.zone-valid');
        }
        break;
      default:
        break;
    }
    return errorMsg;
  }

  checkAreaValue() {
    if (this.addGateForm.value['area'] >= this.schoolArea) {
      this.addGateForm.controls['area'].setErrors({ 'incorrect': true });
      this.addGateForm.controls['area'].markAsTouched();
    }
    if (this.addGateForm.controls['lat'].value == null ){
      this.addGateForm.controls.lat.setValue(this.gate.lat);
      this.addGateForm.controls.long.setValue(this.gate.long);
    }
  }

  zoneChanged(event) {
    this.gate.area = +event.target.value;
    this.setMapData();
  }

  setMapData() {
    this.mapControls = {
      mapPoint: {
        lat: this.gate.lat,
        long: this.gate.long,
      },
      mapaddress: [{
        lat: this.gate.lat,
        long: this.gate.long,
      }],
      mapRoutes: [],
      circles: [
        {
          lat: this.gate.lat,
          long: this.gate.long,
          color: 'green',
          radius: this.gate.area,
        }
      ]
    }
  }

  mapEventHandle(event) {
    switch (event.type) {
      case "mapClicked":
        this.mouseClickedOnMap(event.data);
        break;
    }
  }

  mouseClickedOnMap(data) {
    // if (this.mode == "edit" || this.mode === 'add') {
    this.gate.lat = data.lat;
    this.gate.long = data.long;
    this.addGateForm.controls['lat'].setValue(data.lat);
    this.addGateForm.controls['long'].setValue(data.long);
    this.setMapData();
    // }
  }

  saveGate() {    
    let gateKeys = ['name', 'area', 'long', 'lat', 'guards_ids','grade_ids'];
    let body = {};
    for (const key of gateKeys) {
      body[key] = this.addGateForm.value[key];
      if (key === 'guards_ids' && (this.addGateForm.value[key] === ''||this.addGateForm.value[key] === null)) {
        body[key] = [];
      }
      if (key === 'grade_ids' && (this.addGateForm.value[key] === ''||this.addGateForm.value[key] === null)) {
        body[key] = [];
      }
    }
    if (this.mode === 'add') {
      this.gateService.addGate(body).subscribe((res: any) => {
        this.gateService.setGatesReload();
        this.dataService.allGates.push(res);
        this.dataService.setAllGates$(this.dataService.allGates);
        this.dataService.updateGradesCache();
        this.closeModalHandler();
      }, err => {
        this.errorHandler(err);
      })
    }
    else {
      // user editing gate
      this.gateService.updateGate(body, this.gateId).subscribe(res => {        
        this.gateService.setGatesReload();
        let gateIndex=this.dataService.allGates.findIndex((gate=> gate.id == this.gateId));
        this.dataService.allGates[gateIndex]=res;
        this.dataService.setAllGates$(this.dataService.allGates);
        this.dataService.updateGradesCache();
        this.closeModalHandler();
      }, err => {
        this.errorHandler(err);
      })
    }
  }

  openInfo() {
    this.infoClass = !this.infoClass;
  }

  closeModalHandler() {
  
    this.mode = 'add';
    this.translate.get('init').subscribe(res => {
      this.state = this.translate.instant('gates.add-gate-modal.add')
    });
    this.translate.onLangChange.subscribe(res => {
      this.state = this.translate.instant('gates.add-gate-modal.add')
    });
    this.gateId = null;
    this.modalClosed = true;
    this.addGateForm.controls['guards_ids'].setValue('');
    this.addGateForm.controls['grade_ids'].setValue('');
    this.addGateForm.controls.lat.setValue(this.gate.lat);
    this.addGateForm.controls.long.setValue(this.gate.long);
    this.gate.area=0;
    this.initMapControls();
    this.addGateForm.reset();
    this.gateService.setGateData(null)
    this.gateService.setGatesReload()
    $('#addGateModal').modal('hide');
  }
  initMapControls(){
    this.mapControls ={
      mapPoint: {
        lat: this.gate.lat,
        long: this.gate.long,
      },
      mapaddress: [{
        lat: this.gate.lat,
        long: this.gate.long,
      }],
      mapRoutes: [],
      circles: [
        {
          lat: this.gate.lat,
          long: this.gate.long,
          color: 'green',
          radius: 0,
        }
      ]
    }
  }
  mapPrimeSelectArrays(array:any[] , type:string){ 
    switch (type) {
      case 'grade':
        this.primeSelectGrades = array?.map(grade=> ({
          value:grade.id,
          label:grade.name
        }));
        break;
        case 'guard':
          this.primeSelectSecurities = array?.map(guard=> ({
            value:guard.id,
            label:guard.name
          }));
          break;
      default:
        break;
    }
  }

  primeSelectChanged (event , type) {
    // to make the dropdown still opened 
    event?.originalEvent?.stopPropagation();
    switch (type) {
      case 'grades':
        this.multiSelectgrades.show();
        break;
        case 'guards':
        this.multiSelectguards.show();
        break;
      default:
        break;
  }
}
errorHandler(err:any){
  if(err?.error?.errors?.area){
  this.errorMsgService.setMessage(err?.error?.errors?.area[0]);
}
  else {
  this.errorMsgService.setMessage(err?.error?.message);
}
}
}


